(function(){
  'use strict';
  const ready=new WeakSet();
  function init(root){
    root.querySelectorAll('[data-ck-video]').forEach(card=>{
      if(ready.has(card))return;ready.add(card);
      const video=card.querySelector('video'),button=card.querySelector('[data-ck-play]'),status=card.querySelector('[data-ck-video-status]');
      if(!video||!button)return;
      function message(text){if(status){status.textContent=text;status.hidden=!text;}}
      video.addEventListener('loadedmetadata',()=>{if(!video.poster&&video.currentTime===0&&video.duration>0.1)video.currentTime=0.1;});
      video.addEventListener('play',()=>{document.querySelectorAll('[data-ck-video] video').forEach(other=>{if(other!==video)other.pause();});card.classList.add('is-playing');video.controls=true;message('');});
      video.addEventListener('pause',()=>card.classList.remove('is-playing'));
      video.addEventListener('ended',()=>card.classList.remove('is-playing'));
      video.addEventListener('error',()=>{card.classList.remove('is-playing');message('Unable to load video. Tap play to retry.');});
      button.addEventListener('click',async()=>{try{message('');if(video.error)video.load();await video.play();}catch{message('Unable to play. Please try again.');}});
    });
    if(window.lucide)window.lucide.createIcons();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('[data-ck-video] video').forEach(v=>v.pause());});
})();
